//@ts-nocheck
import React, { useEffect, useState, useCallback } from "react";
import {
  Button,
} from "react-bootstrap";
import {
  PayloadSteps,
  Steps
} from "../../Stepper.constants";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import {
  MissionStore,
  setEditPayloadData,
  setFilterPayloadDeviceList,
  setIsNewPayloadCatalog,
  setIsPayloadEdit,
  setPayloadIndex,
  setPayloadSliderFalse,
} from "../../../../../store/MissionSlice";
import { toast } from "react-toastify";
import PayloadSlider from "./PayloadSlider";
import { calculatePayloadUsage, calculate_Total_AOP_Usage, navigateTo, navigateToWithState, uuidv4 } from "../../../../../utils/commonFunctions";
import PageHeader from "../../../../../Layouts/PageHeader/PageHeader";
import { useNavigate, useParams } from "react-router-dom";
import MissionService from "../../../../../service/MissionService";
import { usageStore } from "../../../../../store/UsageSlice";
import CloseButton from "../../../../CommonComponents/CloseButton";
import SecondStep from "./PayloadStepper/SecondStep";
import FirstStep from "./PayloadStepper/FirstStep";
import Loader from "../../../../../Layouts/Loader/Loader";
import { showToastMessage } from "../../../../../utils/commonFunctions";

const Payloads = () => {
  const params = useParams()
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { mission_name, mission_id, sat_name, sat_id, payload_name, payload_id } = params

  const [selectedPayload, setSelectedPayload] = useState({})
  const [payloadSliderData, setPayloadSliderData] = useState({})

  const [pyloadSrc, setPyloadSrc] = useState<string>("");
  const [payloadCatalouge, setPayloadCatalouge] = useState<string>("");
  const [payloadType, setPayloadType] = useState('');
  const [payloadSubType, setPayloadSubType] = useState("");
  const [loading, setLoading] = useState(true);
  const [satName, setSatName] = useState("")
  //...................................................//
  const [hover, setHover] = useState(true)
  const [satPayloads, setSatPayloads] = useState<any[]>([]);
  const [satellieteDeta, setSatellieteData] = useState<any>({});
  const isPayloadSlider = useSelector((state: { mission: MissionStore }) => state.mission.isPayloadSlider);
  const isNewPayloadCatalog = useSelector((state: { mission: MissionStore }) => state.mission.isNewPayloadCatalog);
  const payloadIndex = useSelector((state: { mission: MissionStore }) => state.mission.payloadIndex);

  const [deleteCatalougeId, setDeleteCatalougeId] = useState<any>('');
  //...................................................//

  const [selectedBands, setSelectedBands] = useState<any>([]);

  const payloadSizeUsage = useSelector((state: { usage: usageStore }) => state.usage.payloadSizeUsage);
  const payloadWeightUsage = useSelector((state: { usage: usageStore }) => state.usage.payloadWeightUsage);
  const payloadPowerUsage = useSelector((state: { usage: usageStore }) => state.usage.payloadPowerUsage);
  const totalPayloadAOPUsage = useSelector(
    (state: { usage: usageStore }) => state.usage.totalPayloadAOPUsage
  );

  const isEditPayload = useSelector(
    (state: { mission: MissionStore }) => state.mission.isEditPayload
  );
  const EditPayloadData = useSelector(
    (state: { mission: MissionStore }) => state.mission.EditPayloadData
  );

  const [userInput, setUserInput] = useState<any>({
    payloadName: '',
    time_per_orbit: '5',
    AltMeasureAccuracy: '1',
    downlinkDatasize: '1',
  });



  useEffect(() => {
    if (sat_id) {
      MissionService.get_satellite_by_sat_id(sat_id, mission_id)?.then((sat) => {
        if (sat?.data) {
          setSatName(sat?.data?.name)
          //here might need to call edge api for edit case
          MissionService.get_payload_by_sat_id(sat_id, mission_id)?.then((payalod) => {
            const payloads = payalod?.data ? payalod?.data : []
            setSatPayloads(payloads)
            setSatellieteData(sat?.data)
            calculatePayloadUsage(payloads, dispatch);
            calculate_Total_AOP_Usage(payloads, [], dispatch);
            if (payload_id) {
              let edit_payload = payloads.find(
                (pay) =>
                  (pay?.['userData']?.['id'] === payload_id) ||
                  (pay?.['userData']?.['id'] === payload_id)
              );
              dispatch(setEditPayloadData(edit_payload));
              dispatch(setIsPayloadEdit(true));
            } else {
              setLoading(false)
            }
            if (isNewPayloadCatalog) {
              dispatch(setIsNewPayloadCatalog(false))
            }

          }).catch((err) => {
            showToastMessage('error', "Error in getting payloads")
          })
        }
      }).catch((err) => {
        console.log('Some thing went wrong while getting satellite');
        setLoading(false)
      })
    }
    dispatch(setPayloadIndex(1))
  }, [sat_id]);

  // Handle clicks outside PayloadSlider to close summary
  const handleClickOutside = useCallback((event: MouseEvent) => {
    const target = event.target as Element;
    if (
      isPayloadSlider &&
      !target.closest('.right-slider-box')
    ) {
      dispatch(setPayloadSliderFalse());
    }
  }, [isPayloadSlider, dispatch]);

  useEffect(() => {
    if (isPayloadSlider) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [isPayloadSlider, handleClickOutside]);


  const getSatelliteFormData = () => {
    let sat = {
      ...satellieteDeta,
      swapInfo: {
        ...satellieteDeta?.swapInfo,
        totalPayloadSize: payloadSizeUsage,
        totalPayloadMass: payloadWeightUsage,
        totalPayloadPower: payloadPowerUsage,
        totalPayloadAop: totalPayloadAOPUsage,
      }
    }
    return sat
  }

  const getPayloadFormData = (payloadDeysils: any) => {
    let atmosData = payloadDeysils?.['atmosData']
    let userData = payloadDeysils?.['userData']
    delete atmosData?.['updatedAt']
    let payload = {
      atmosData,
      userData,
      name: userData?.['payload_name'],
      missionId: mission_id,
      catalogueId: atmosData?.['uniqueId'],
      satelliteGroupId: sat_id,
      sequences: payloadDeysils?.['sequences'],
      metrics: payloadDeysils?.['metrics'],
      epsChannel: "",
    };
    return payload
  }

  const addPayload = async (payloadDeysils: any) => {
    setLoading(true)
    let payload = getPayloadFormData(payloadDeysils);
    try {
      if (isEditPayload) {
        const update_with_new_payload = EditPayloadData?.['atmosData']?.['uniqueId'] !== selectedPayload?.['atmosData']?.['uniqueId']
        if (update_with_new_payload) {
          await MissionService.delete_payload(mission_id, sat_id, EditPayloadData?.['uniqueId'])
          await MissionService.add_payload(sat_id, mission_id, payload)
        } else {
          await MissionService.update_payload_by_payload_id(mission_id, sat_id, EditPayloadData?.['uniqueId'], payload)
        }
      } else {
        await MissionService.add_payload(sat_id, mission_id, payload)
      }
      const response = await MissionService.get_satellite_by_sat_id(sat_id, mission_id)
      const satelliteDetails = response?.data

      const swapInfo = {
        totalPayloadSize: payloadSizeUsage,
        totalPayloadMass: payloadWeightUsage,
        totalPayloadPower: payloadPowerUsage,
        totalPayloadAop: totalPayloadAOPUsage,
        totalEdgeMass: satelliteDetails?.swapInfo?.totalEdgeMass || 0,
        totalEdgePower: satelliteDetails?.swapInfo?.totalEdgePower || 0,
        totalEdgeSize: satelliteDetails?.swapInfo?.totalEdgeSize || 0,
        totalEdgeAop: satelliteDetails?.swapInfo?.totalEdgeAop || 0,
      }
      const updatedSatellite = {
        ...satelliteDetails,
        draftMode: true,
        templateId: '',
        swapInfo: swapInfo
      }
      await MissionService.edit_satellite(mission_id, sat_id, updatedSatellite)

      if (isEditPayload) {
        dispatch(setIsPayloadEdit(false));
        dispatch(setEditPayloadData({}));
      }
      //Toast on destination page so user sees it after preview loads
      const successMessage = `Payload ${isEditPayload ? 'updated' : 'added'} successfully`;
      navigateToWithState(
        `${mission_name}/${mission_id}/${sat_name}/${sat_id}/preview_payload`,
        navigate,
        { payloadSuccessMessage: successMessage }
      );
    } catch (error) {
      showToastMessage('error', `Something went wrong while ${isEditPayload ? 'updating' : 'adding'} the payload `);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (payloadIndex === 1 && Object.keys(selectedPayload).length > 0) {
      const filter_payloads = satPayloads?.filter(pay => pay?.['userData']?.['id'] !== selectedPayload?.['userData']?.['id'])
      calculatePayloadUsage(filter_payloads, dispatch);
      calculate_Total_AOP_Usage(filter_payloads, [], dispatch);
    }
  }, [payloadIndex])

  const onPreviousStepper = () => {
    if (payloadIndex !== 0) {
      dispatch(setPayloadIndex(payloadIndex - 1));
      setHover(true)
      dispatch(setFilterPayloadDeviceList([]));
    }
  };


  useEffect(() => {
    if (isEditPayload) {
      dispatch(setPayloadIndex(2))
      const atmosData = EditPayloadData?.["atmosData"] || EditPayloadData?.["atmosData"];
      if (atmosData) {
        setPayloadCatalouge(atmosData?.["component_specific_attributes"]?.["payloadType"]);
        setSelectedPayload(EditPayloadData);
        setPayloadSliderData(EditPayloadData);
        setPyloadSrc(atmosData?.["src"]);
      }
    }
  }, [isEditPayload]);
  const onNextStepper = () => {
    if (onCheckSteps()) {
      if (payloadIndex === 1) {
        dispatch(setPayloadIndex(payloadIndex + 1))
        setLoading(true)
      } else if (payloadIndex === 2) {
        // Check payload name validation only at step 2
        if (!userInput?.payloadName || userInput.payloadName.trim() === '') {
          showToastMessage('error', 'Payload Name is required');
          return; // stop further execution
        }
        if ((userInput?.['time_per_orbit'] !== '' && Number(userInput?.['time_per_orbit']) > 0) && userInput?.['AltMeasureAccuracy'] !== '') {
          addPayload(selectedPayload)
        } else {
          showToastMessage('error', `${(userInput?.['time_per_orbit'] === '' || Number(userInput?.['time_per_orbit']) <= 0) ? 'Average Active Duration per orbit can not be 0 or empty' : 'Pointing Accuracy is required'}`);
        }
      }
    }
  };



  const onCheckSteps = () => {
    if ((payloadIndex === 1) && (payloadCatalouge === "")) {
      showToastMessage('error', "Select any payload category to proceed");
      return false
    } else if (payloadIndex === 2 && Object.keys(selectedPayload).length === 0) {
      showToastMessage('error', "Select any device to proceed");
      return false
    } else if (payloadIndex === 2 && Object.keys(selectedPayload).length > 0) {
      const all_payloads = isEditPayload ? satPayloads?.filter(pay => pay?.['userData']?.['id'] !== payload_id) : satPayloads
      const payload_name_exist = all_payloads?.find(pay => pay?.['userData']?.['payload_name'].toLowerCase().trim() === selectedPayload?.['userData']?.['payload_name'].toLowerCase().trim())
      if (payload_name_exist) {
        showToastMessage('error', "Payload name already exist");
        return false
      } else {
        return true
      }
    }
    else {
      return true
    }
  };


  const onSelectPayload = (data) => {
    setPayloadCatalouge(data?.type);
    setPyloadSrc(data?.['src']);
  };

  const navigate_to_step = (step) => {
    if (isEditPayload) {
      dispatch(setIsPayloadEdit(false));
      dispatch(setEditPayloadData({}));
    }
    if (satPayloads?.length > 0) {
      if (step === 'Payloads' && satEdges?.length > 0) {
        navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/preview_payload`, navigate)
      }
      if (step === 'Edge') {
        navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/preview_edge`, navigate)
      }
    } else {
      showToastMessage('error', "Select any device to proceed")
    }
  }

  return (
    <div className='h-100 w-100'>
      {loading && <Loader />}
      <PageHeader
        sat_name={satName}
        titles={!isNewPayloadCatalog ? "Configure Payload Device" : "Add Payload Device"}
        description={!isNewPayloadCatalog ? "Payloads currently configured in this satellite" : "Define a new payload device for this satellite"}
        active="New Mission"
        items={["Apps"]}
        isButton={false}
        showSwap={true}
        showPercent={false}
        type=''
        value=''
      />
      {payloadIndex === 1 && (<div className="gap-3 p-0">
        <div className="row-cards row-box mt-5">
          <div className=" ">
            <ol className="c-stepper">
              {PayloadSteps.map((data) => {
                return (
                  <li
                    key={data.stepIndex}
                    className={
                      payloadIndex === data.stepIndex
                        ? "c-stepper__item active"
                        : payloadIndex > data.stepIndex
                          ? "done c-stepper__item"
                          : "c-stepper__item"
                    }
                  >
                    <h3 className="c-stepper__title">{data.title}</h3>
                  </li>
                );
              })}
            </ol>
          </div>
        </div>
        <FirstStep payloadCatalouge={payloadCatalouge} onSelectPayload={onSelectPayload} />
      </div>)}
      {payloadIndex === 2 && (
        <SecondStep payloadCatalouge={payloadCatalouge} setPayloadCatalouge={setPayloadCatalouge} satPayloads={satPayloads} pyloadSrc={pyloadSrc}
          setPayloadType={setPayloadType} payloadType={payloadType} setPayloadSubType={setPayloadSubType} payloadSubType={payloadSubType} selectedPayload={selectedPayload} setPayloadSliderData={setPayloadSliderData}
          setSelectedBands={setSelectedBands} selectedBands={selectedBands} setSelectedPayload={setSelectedPayload} setLoading={setLoading} setUserInput={setUserInput} userInput={userInput} satellieteDeta={satellieteDeta}
        />
      )}

      {isPayloadSlider && (
        <PayloadSlider payloadSliderData={payloadSliderData} />
      )}

      {/* //................................................................// */}

      {!isNewPayloadCatalog && <div className="navigator-btn gap-3">
        {(payloadIndex === 1 && satPayloads?.length === 0) && <CloseButton />}
        {satPayloads?.length > 0 && <Button
          variant="primary-outline"
          type="button"
          className="btn btn-outline-danger pt-1 pb-1 pe-6 ps-6 me-2 fs-14"
          onClick={() => {
            if (isEditPayload) {
              dispatch(setIsPayloadEdit(false));
              dispatch(setEditPayloadData({}));
            }
            navigateTo(`${mission_name}/${mission_id}/${sat_name}/${sat_id}/preview_payload`, navigate)
          }}
        >
          Cancel
        </Button>}
        <div className="btn-group btn-grp-nav">
          {payloadIndex !== 1 && <Button
            variant={hover ? "outline-primary" : "primary"}
            type="button"
            className={`d-flex align-items-center btn ${hover ? "btn-outline-primary" : "btn-primary"
              } pt-1 pb-1 pe-4 ps-3 fs-14`}
            onClick={onPreviousStepper}
            onMouseEnter={() => {
              setHover(false);
            }}
            onMouseLeave={() => {
              setHover(true);
            }}
          >
            <i className="fe fe-chevron-left me-1 fs-16"></i> Back
          </Button>}
          <Button
            variant={hover ? "primary" : "outline-primary"}
            type="submit"
            className={`d-flex align-items-center btn ${hover ? "btn-primary" : "btn-outline-primary"
              } pt-1 pb-1 pe-3 ps-4 fs-14`}
            onClick={onNextStepper}
          >
            {payloadIndex !== 2 ? "Next" : isEditPayload ? 'Update Payload' : 'Save & Continue'}
            <i className="fe fe-chevron-right ms-1 fs-16"></i>
          </Button>
        </div>
      </div>}


      {!isNewPayloadCatalog && <div className="stepper-container">
        <div className="breadcrumb">
          {Steps.map((data) => {
            return <a
              onClick={() => {
                navigate_to_step(data.title)
              }}
              className={data.title === 'Payloads' ? 'active' : ''}
              key={data.title}>
              <span className={"breadcrumb__inner"}>
                <span className="breadcrumb__title">
                  {data.svg}
                </span>
                <span className={"breadcrumb__desc"}>{data.title}</span>
              </span>
            </a>
          })}
        </div>
      </div>}
    </div>
  );
};
export default Payloads;
